module.exports = __webpack_public_path__ + "static/img/a099.6031e17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a099.jpg
// module id = inO7
// module chunks = 0